import { render, staticRenderFns } from "./ColaboradoresView.vue?vue&type=template&id=273c0eba&scoped=true&"
import script from "./ColaboradoresView.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresView.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradoresView.vue?vue&type=style&index=0&id=273c0eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c0eba",
  null
  
)

export default component.exports